import {Base} from "@/api/Base"

export class AdvisorEdit extends Base {
    path = "advisor/edit"
}